import { render, staticRenderFns } from "./ProcessDangerInfo.vue?vue&type=template&id=66ae8610&scoped=true"
import script from "./ProcessDangerInfo.vue?vue&type=script&lang=js"
export * from "./ProcessDangerInfo.vue?vue&type=script&lang=js"
import style0 from "./ProcessDangerInfo.vue?vue&type=style&index=0&id=66ae8610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae8610",
  null
  
)

export default component.exports